"use client";

import { Button } from "@src/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@src/components/ui/card";
import { QueryErrorResetBoundary } from "@tanstack/react-query";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
export const ErrorBoundary = ({
  children
}: {
  children: React.ReactNode;
}) => {
  return <QueryErrorResetBoundary data-sentry-element="QueryErrorResetBoundary" data-sentry-component="ErrorBoundary" data-sentry-source-file="ErrorBoundary.tsx">
      {({
      reset
    }) => <ReactErrorBoundary onReset={reset} fallbackRender={({
      error: _,
      resetErrorBoundary
    }) => <Card className="w-full max-w-md">
            <CardHeader className="text-center">
              <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-destructive/10">
                <AlertTriangle className="size-6 text-destructive" />
              </div>
              <CardTitle className="text-xl">Something went wrong!</CardTitle>
              <CardDescription>
                An error occurred that prevented the application from loading. This has been reported automatically.
              </CardDescription>
            </CardHeader>
            <CardContent className="text-center">
              <Button onClick={() => {
          resetErrorBoundary();
        }} className="w-full">
                <RefreshCw className="mr-2 size-4" />
                Try again
              </Button>
            </CardContent>
          </Card>}>{children}</ReactErrorBoundary>}
    </QueryErrorResetBoundary>;
};